'use strict';
const util = require('../components/util');

module.exports = {
    productTileSlider: function () {
        if (util.isMobile()) {
            $('.js-tile-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false
            });
        } else if ($('.js-tile-slider').hasClass('slick-initialized')) {
            $('.js-tile-slider').slick('unslick');
        }

        var $carousel = $('.js-recommendation-carousel').filter(function () {
            return !$(this).parent().is('.carousel-wrapper-element');
        });

        if ($carousel.length) {
            $carousel.find('.js-tile-slider').slick('unslick');
        }
    }
};
